<template>
    <div>
        <v-card class="my-shadow">
            <v-card-title  class="v-card-title-text">
                {{$t('Add Product colors')}}
                <v-spacer></v-spacer>
                <v-btn @click="addGroup()" color="secondary" dark>{{$t('Add')}}</v-btn>
            </v-card-title>
            <div v-if="error_colors || $product.product.variants.length===0" style=" padding-left: 16px;" class="v-messages theme--light error--text" role="alert">
                <div class="v-messages__wrapper">
                    <div class="v-messages__message">This element is required</div>
                </div>
            </div>
            <v-expansion-panels>
                <div class="row">
                    <div class="col-md-12">
                        <v-expansion-panel
                            v-for="(variant,i) in $product.product.variantsToDIsplay"
                            :key="i"

                        >
                            <div class="row">
                                <div class="col-md-11 mr-0">
                                    <v-expansion-panel-header @click="selectedVariants=[]" class="pt-0 pb-0">
                                        <v-img v-if="$product.product.variants.filter(item=>item.attributes[0].value===variant).length>0 && $product.product.variants.filter(item=>item.attributes[0].value===variant)[0].photos" :src="$root.getSrc($product.product.variants.filter(item=>item.attributes[0].value===variant)[0].photos[0])" max-width="50px" contain max-height="50px"></v-img>
                                        <span v-else>{{$t('No photo')}}</span>
                                        <span>{{ variant }}</span>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <v-card-text style="padding: 0;">
                                            <v-data-table show-select v-model="selectedVariants" :headers="headers" :items="$product.product.variants.filter(item=>item.attributes[0].value===variant)">
                                                <template v-slot:item.photos="{item}">
                                                    <v-img v-if="item.photos" :src="$root.getSrc(item.photos[0])" max-width="50px" contain max-height="50px"></v-img>
                                                    <span v-else>{{$t('No photo')}}</span>
                                                </template>
                                                <template v-slot:item.sku="{item}">
                                                    <span v-chunk>{{item.sku}}</span>
                                                </template>
                                                <template v-slot:item.color="{item}">
                                                    <span>{{item.attributes.find(x => x.name == 'Color').value}}</span>
                                                </template>
                                                <template v-slot:item.size="{item}">
                                                    <span>{{$t(item.attributes.find(x => x.name == 'Size').value)}}</span>
                                                </template>
                                                <template v-slot:item.actions="{item,index}">
                                                    <v-btn x-small fab class="ma-1" color="red" @click="deleteSingleVariant(item)"><v-icon class="white--text">mdi-trash-can</v-icon></v-btn>
                                                    <v-btn x-small fab class="ma-1" color="primary" @click="editVariant(item, index)"><v-icon class="white--text">mdi-pencil</v-icon></v-btn>
                                                </template>
                                                <template v-slot:item.price="{item, index}">
                                                    <v-text-field style="min-width: 120px" :min="0" v-if="getVariantIndex != -1" @change="$product.$set($product.product.variants[getVariantIndex(item)], 'price', $event)" class="no-validation" outlined dense type="number" step="0.01" :value="item.price" label="Color price margin" hint="Leave this field empty if this color should have main price"></v-text-field>
                                                </template>
                                                <template v-slot:item.smake_id="{item}">
                                                    <span v-if="item.smake_id && item.smake_id != ''">{{item.smake_id}}</span>
                                                    <span class="red--text" style="font-size: 0.8rem" v-else>{{$t('This item cant be saved. No smake ID')}}</span>
                                                </template>
                                                <template v-slot:item.generated_photos="{item}">
                                                    <div class="d-flex flex-wrap">
                                                        <div style="position: relative" v-for="(pht,ind) in item.generated_photos">
                                                            <v-img :src="$root.getSrc(pht.src)" max-width="40px" max-height="40px"></v-img>
                                                            <v-btn x-small absolute style="top:-10px; left: -10px; width: 15px; height: 15px;" dark @click="item.generated_photos.splice(ind, 1)" fab color="red" ><v-icon style="font-size: 10px;">mdi-trash-can</v-icon></v-btn>
                                                            <!--                                <v-btn absolute style="top:-10px; left: -10px" color="red" icon x-small @click="item.generated_photos.splice(ind, 1)"><v-icon>mdi-trash-can</v-icon></v-btn>-->
                                                        </div>
                                                    </div>
                                                </template>
                                            </v-data-table>
                                        </v-card-text>
                                    </v-expansion-panel-content>
                                </div>
                                <div class="col-md-1 d-flex pt-5 pl-0">
                                    <v-btn x-small dark fab @click="deleteWholeVariant(variant)" color="red" ><v-icon style="font-size: 15px;">mdi-trash-can</v-icon></v-btn>
                                </div>
                            </div>
                        </v-expansion-panel>
                    </div>

                </div>

            </v-expansion-panels>
            <v-card-text>
                <div v-if="selectedVariants.length > 0" class="mt-3">
                    <p>Assign photo to multiple colors</p>
                    <div class="my-3">
                        <media-picker v-model="assign_photo" :show_elements="true"></media-picker>
                        <v-text-field max-width="300px" outlined type="number" v-model="assign_price" step="0.01" min="1" :label="$t('Set margin price for selected colors')"></v-text-field>
                    </div>
                    <v-btn v-if="assign_photo != null" class="mr-3" color="secondary" @click="assignPhotos()" dark>{{$t('Assign photo to selected')}}</v-btn>
                    <v-btn v-if="selectedVariants.length > 0" color="secondary" @click="updatePrice()" dark>{{$t('Update price in selected colors')}}</v-btn>
                    <v-btn v-if="selectedVariants.length > 0" class="ml-3" color="red" @click="deleteSelected()" dark>{{$t('Delete selected colors')}}</v-btn>
                </div>
            </v-card-text>
<!--            <v-card-actions class="d-flex justify-start">-->
<!--                <v-btn @click="addGroup()" color="secondary" dark>{{$t('Add variants group')}}</v-btn>-->
<!--                <v-btn @click="addVariant()" color="secondary" dark>{{$t('Add single variant')}}</v-btn>-->
<!--            </v-card-actions>-->

        </v-card>
    </div>
</template>
<script>
    import {makeid} from "../../helpers";
    import VariantsEditAdd from '../variants/edit-add';
    export default {
        components:{VariantsEditAdd},
        props: ['error_colors'],
        data:() => {
            return{
                selectedVariants:[],
                assign_photo:null,
                assign_price:null,
                variants: []
            }
        },
        computed:{
            headers(){
                var headers = [
                    {
                        text: 'Image',
                        value: 'photos',
                    },
                    {
                        text: 'Size',
                        value: 'size',
                        width: '80px',
                        sortable: false,
                    },
                    {
                        text: 'Color',
                        value: 'color',
                        sortable:false,
                    },
                    {
                        text: 'Actions',
                        value: 'actions',
                        align: 'center'
                    }
                ];
                if(this.$route.params.id != 'create'){
                    headers.push({
                        'text': 'Generated photos',
                        'value': 'generated_photos'
                    })
                }
                return headers;
            }
        },
        methods:{
            assignPhotos(){
                if(this.assign_photo){
                    this.selectedVariants.forEach(item => {
                        var index = this.$product.product.variants.findIndex(x => x == item);
                        if(index != -1){
                            this.$product.$set(this.$product.product.variants[index], 'photos', [this.assign_photo]);
                        }
                    })
                }
            },
            updatePrice(){
                this.selectedVariants.forEach(item => {
                    var index = this.$product.product.variants.findIndex(x => x == item);
                    if(index != -1){
                        this.$product.$set(this.$product.product.variants[index], 'price', this.assign_price);
                    }
                })
                this.selectedVariants = [];
            },
            getVariantIndex(variant){
                return this.$product.product.variants.findIndex(x => x == variant);
            },
            addGroup(){
                this.$variants.addVariant(null, true).then(response => {
                    response.forEach(item => {
                        var finded = this.$product.product.variants.find((x) => {
                            var check_color = x.attributes.find(y => y.name == 'Color' && y.value == item.color);
                            var check_size =  x.attributes.find(y => y.name == 'Size' && y.value == item.size);
                            if(check_size && check_color) return true;
                            return false;
                        })
                        if(!finded){
                            var color = item.color;
                            var size = item.size;
                            var smakeData = this.$product.product.smake.data.variants;
                            var finded_2 = smakeData.find(x => {
                                return x.attributes.find(y => y.name == 'color' && y.value == color) && x.attributes.find(y => y.name == 'size' && y.value == size);
                            })
                            if(!finded_2){
                                var str = 'color: '+item.color+' size: '+item.size;
                                // this.$store.commit('app/ADD_MESSAGE', {text: this.$t('Smake variant')+' '+str+' not found', type:'error'});
                                return false;
                            }
                            var sku = item.color+'_'+item.size;
                            let front_print=null,back_print=null,color_swatch=null;
                            if(finded_2.front_print) front_print = finded_2.front_print;
                            if(finded_2.back_print) back_print = finded_2.back_print;
                            if(finded_2.color_swatch) color_swatch = finded_2.color_swatch;
                            var obj = {
                                show:true,
                                smake_id: finded_2.id,
                                sku:sku,
                                id: makeid(20),
                                attributes:[],
                                front_print,
                                back_print,
                                color_swatch,
                                price: item.price
                            }
                            obj.attributes.push({
                                custom: false,
                                name: 'Color',
                                type: 'color',
                                value: item.color
                            })
                            obj.attributes.push({
                                custom: false,
                                name: 'Size',
                                type: 'text',
                                value: item.size
                            })
                            if(item.images){
                                obj.photos = item.images.map((item) => {
                                    return item.image;
                                })
                            }
                            this.$product.product.variants.push(obj);
                        }
                    })
                })
            },
            deleteSingleVariant(item){
                this.$product.product.variants = this.$product.product.variants.filter(function( obj ) {
                    return obj.id !== item.id;
                });
            },
            deleteSelected(){
                this.selectedVariants.forEach(item => {
                    var index = this.$product.product.variants.findIndex(x => x == item);
                    if(index != -1) this.$product.product.variants.splice(index, 1);
                })
                this.selectedVariants = [];
            },
            addVariant(){
                var sizes = this.$product.smakeVariants;
                this.$variants.addVariant().then(response => {
                    this.$product.product.variants.push(response);
                })
            },
            editVariant(variant, variant_index){
                this.$variants.addVariant(variant).then(response => {
                    this.$product.product.variants[variant_id] = response;
                })
            },
            deleteWholeVariant(variant){
                this.$product.product.variantsToDIsplay = this.$product.product.variantsToDIsplay.filter(variantToDisplay=>variantToDisplay!==variant);
                this.$product.product.variants=this.$product.product.variants.filter(single=>{
                    return single.attributes[0].value !== variant;
                });
            }
        }
    }
</script>
